import { APISettings } from '../../config/ApiSettings';
import { BaseAPI } from './baseApi';

const baseUrl = new APISettings().getApiURL();

class ClaimApi<Claim> extends BaseAPI {
  public getClaimsByUserId: (id: string) => Promise<Claim[]> = async (id: string) => {
    return (await BaseAPI.axios.get(`${baseUrl}/claim/${id}`)).data.output;
  };

  public addUserClaim: (claim: any) => Promise<Claim[]> = async (claim: any) => {
    return (await BaseAPI.axios.post(`${baseUrl}/claim/`, claim)).data.output;
  };

  public removeUserClaimById: (id: string) => Promise<Claim> = async (id: string) => {

    return (await BaseAPI.axios.delete(`${baseUrl}/claim/${id}`)).data.output;
  };
}

export const claimAPI = new ClaimApi();
